import { getCsrfToken } from "./csrf";

const BASE = "/api";

export interface DevNotification {
  id: number;
  submission_id: number;
  message: string;
  seen: boolean;
  created_at: string;
}

export async function fetchNotifications(): Promise<{
  data: DevNotification[];
}> {
  const res = await fetch(BASE + "/submissions/notifications", {
    credentials: "include",
  });
  const data = await res.json();
  if (!res.ok)
    throw new Error(
      (data as { error?: string }).error ??
        `GET /submissions/notifications: ${res.status}`,
    );
  return data as { data: DevNotification[] };
}

export async function markNotificationsSeen(ids?: number[]): Promise<void> {
  const csrfToken = await getCsrfToken();
  const body: Record<string, unknown> = ids ? { ids } : {};
  const res = await fetch(BASE + "/submissions/notifications/seen", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(
      (data as { error?: string }).error ??
        `POST /submissions/notifications/seen: ${res.status}`,
    );
  }
}

/* ── New notification center endpoints ── */

export interface NotificationItem {
  id: number;
  submission_id: number;
  message: string;
  seen: number;
  created_at: string;
  submission_title?: string;
}

export interface NotificationsPage {
  notifications: NotificationItem[];
  page: number;
  pages: number;
  total: number;
}

export async function listNotifications(page = 1): Promise<NotificationsPage> {
  const res = await fetch(`${BASE}/notifications?page=${page}`, {
    credentials: "include",
  });
  if (!res.ok) throw new Error(`Failed to load notifications: ${res.status}`);
  return res.json();
}

export async function getUnreadCount(): Promise<number> {
  const res = await fetch(`${BASE}/notifications/unread`, {
    credentials: "include",
  });
  if (!res.ok) return 0;
  const data = (await res.json()) as { unread: number };
  return data.unread;
}

export async function markRead(id: number): Promise<void> {
  const csrfToken = await getCsrfToken();
  await fetch(`${BASE}/notifications/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: { "X-CSRF-Token": csrfToken },
  });
}

export async function markAllRead(): Promise<void> {
  const csrfToken = await getCsrfToken();
  await fetch(`${BASE}/notifications/read-all`, {
    method: "PUT",
    credentials: "include",
    headers: { "X-CSRF-Token": csrfToken },
  });
}
